import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import styled from 'styled-components';

import FormControlLabel from 'dashboard/components/FormControls/FormControlLabel';
import { CaseVariableDefinitionAttributes } from 'dashboard/models/case-variable-definition';
import Input from 'design-system/components/Input';

const StyledInput = styled(Input)`
  width: 500px;
`;

interface PlatformObjectQueryEditorProps {
  control: Control<CaseVariableDefinitionAttributes, object>;
}

const PlatformObjectQueryEditor: FC<PlatformObjectQueryEditorProps> = ({ control }) => {
  return (
    <>
      <div>
        <FormControlLabel htmlFor='case_template_general_query_editor--method_chain_input'>
          Query
        </FormControlLabel>
      </div>
      <Controller
        name='variable-definition.method_chain'
        control={control}
        render={({ field: { value, onChange } }) => (
          <StyledInput
            role='input'
            id='case_template_general_query_editor--method_chain_input'
            value={value}
            onChange={(e) => onChange(e.target.value)}
          />
        )}
      />
    </>
  );
};

export default PlatformObjectQueryEditor;
